import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { AdicionarCotacaoFornecedorRequest } from '../../requests/compras/adicionar-cotacao-fornecedor.request';
import { AplicarSelecaoCotacaoRequest } from '../../requests/compras/aplicar-selecao-cotacao.request';
import { AtualizarCotacaoFornecedorRequest } from '../../requests/compras/atualizar-cotacao-fornecedor.request';
import { EnviarCotacaoRequest } from '../../requests/compras/enviar-cotacao.request';
import { GerarLinkCotacaoRequest } from '../../requests/compras/gerar-link-cotacao.request';
import { AplicarSelecaoCotacaoResponse } from '../../responses/compras/aplicar-selecao-cotacao.response';
import { CotacaoFornecedorOperacaoResponse } from '../../responses/compras/cotacao-fornecedor-operacao.response';
import { GerarLinkCotacaoResponse } from '../../responses/compras/gerar-link-cotacao.response';
import { ListarCotacoesFornecedorResponse } from '../../responses/compras/listar-cotacoes-fornecedor.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class CompraCotacaoService extends CommonService {
  private readonly apiUrl: string = environment.urlApiCompras + 'CompraCotacao';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public listarCotacoes(idCompra: number): Observable<ListarCotacoesFornecedorResponse> {
    return this.httpClient
      .get<ListarCotacoesFornecedorResponse>(`${this.apiUrl}/${idCompra}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public baixarModeloCotacao(idCompra: number, formato: 'csv' | 'xlsx' | 'pdf'): Observable<Blob> {
    return this.httpClient
      .get(`${this.apiUrl}/${idCompra}/modelo?formato=${formato}`, { headers: this.addHeaderToken().headers, responseType: 'blob' });
  }

  public adicionarCotacaoFornecedor(idCompra: number, request: AdicionarCotacaoFornecedorRequest): Observable<CotacaoFornecedorOperacaoResponse> {
    return this.httpClient
      .post<CotacaoFornecedorOperacaoResponse>(`${this.apiUrl}/${idCompra}`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public atualizarCotacaoFornecedor(idCompra: number, idCotacaoFornecedor: number, request: AtualizarCotacaoFornecedorRequest): Observable<CotacaoFornecedorOperacaoResponse> {
    return this.httpClient
      .put<CotacaoFornecedorOperacaoResponse>(`${this.apiUrl}/${idCompra}/${idCotacaoFornecedor}`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public removerCotacaoFornecedor(idCompra: number, idCotacaoFornecedor: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(`${this.apiUrl}/${idCompra}/${idCotacaoFornecedor}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public gerarLinkCotacao(idCompra: number, idCotacaoFornecedor: number, documento?: string): Observable<GerarLinkCotacaoResponse> {
    const request: GerarLinkCotacaoRequest = { documento };
    return this.httpClient
      .post<GerarLinkCotacaoResponse>(`${this.apiUrl}/${idCompra}/${idCotacaoFornecedor}/link`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public enviarCotacaoFornecedor(idCompra: number, idCotacaoFornecedor: number, destinatario: string, nomeFornecedor?: string, documento?: string,
    idsUsuarioPerfil?: number[]): Observable<CotacaoFornecedorOperacaoResponse> {
    const request: EnviarCotacaoRequest = { destinatario, nomeFornecedor, documento, idsUsuarioPerfil };
    return this.httpClient
      .post<CotacaoFornecedorOperacaoResponse>(`${this.apiUrl}/${idCompra}/${idCotacaoFornecedor}/enviar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public aplicarSelecaoCotacao(idCompra: number, request: AplicarSelecaoCotacaoRequest): Observable<AplicarSelecaoCotacaoResponse> {
    return this.httpClient
      .put<AplicarSelecaoCotacaoResponse>(`${this.apiUrl}/${idCompra}/selecao`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
